import { render } from "./About.vue?vue&type=template&id=417cbeb2&scoped=true"
const script = {}

import "@/assets/css/about.sass?vue&type=style&index=0&id=417cbeb2&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417cbeb2"]])

export default __exports__